import X from "@babel/runtime/helpers/esm/toConsumableArray";
import Y from "@babel/runtime/helpers/esm/objectWithoutProperties";
import T from "@babel/runtime/helpers/esm/slicedToArray";
import W from "@babel/runtime/helpers/esm/extends";
import u from "@babel/runtime/helpers/esm/objectSpread2";
import Z from "@babel/runtime/helpers/esm/classCallCheck";
import ee from "@babel/runtime/helpers/esm/createClass";
import V from "@babel/runtime/helpers/esm/assertThisInitialized";
import I from "@babel/runtime/helpers/esm/get";
import y from "@babel/runtime/helpers/esm/getPrototypeOf";
import te from "@babel/runtime/helpers/esm/inherits";
import re from "@babel/runtime/helpers/esm/createSuper";
import C from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as ne } from "@semcore/utils/lib/core/index";
import oe, { assignProps as h, sstyled as x } from "@semcore/core";
import i from "react";
import ie from "classnames";
import D, { enhance as ae, selectedIndexContext as q, AbstractDropdown as _e } from "@semcore/dropdown";
import { useBox as se, Flex as N } from "@semcore/flex-box";
import k, { hideScrollBarsFromScreenReadersContext as de } from "@semcore/scroll-area";
import { useUID as le } from "@semcore/utils/lib/uniqueID";
import { localizedMessages as ge } from "./translations/__intergalactic-dynamic-locales.mjs";
import { useFocusSource as ue } from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import { isAdvanceMode as A } from "@semcore/utils/lib/findComponent";
import { forkRef as G } from "@semcore/utils/lib/ref";
import { callAllEventHandlers as E } from "@semcore/utils/lib/assignProps";
import ce from "@semcore/button";
import { Text as me } from "@semcore/typography";
var he = ["className"], pe = (
  /*__reshadow_css_start__*/
  (ne.insert(
    /*__inner_css_start__*/
    `.___SDropdownMenuList_1j30o_gg_{max-height:240px;padding:var(--intergalactic-spacing-1x, 4px)0;position:relative;min-height:26px;min-width:32px;box-sizing:content-box;z-index:0;color:var(--intergalactic-text-primary, #191b23)}.___SDropdownMenuList_1j30o_gg_ .___SShadowHorizontal_1j30o_gg_:after,.___SDropdownMenuList_1j30o_gg_ .___SShadowHorizontal_1j30o_gg_:before{width:16px;height:100%;border-radius:var(--intergalactic-control-rounded, 6px)}.___SDropdownMenuList_1j30o_gg_ .___SShadowHorizontal_1j30o_gg_._position_median_1j30o_gg_:before{background:var(--intergalactic-scroll-area-dropdown-menu-left,
        linear-gradient(to right, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowHorizontal_1j30o_gg_._position_median_1j30o_gg_:after{background:var(--intergalactic-scroll-area-dropdown-menu-right,
        linear-gradient(to left, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowHorizontal_1j30o_gg_._position_start_1j30o_gg_:before{background:var(--intergalactic-scroll-area-dropdown-menu-left,
        linear-gradient(to right, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowHorizontal_1j30o_gg_._position_end_1j30o_gg_:after{background:var(--intergalactic-scroll-area-dropdown-menu-right,
        linear-gradient(to left, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowVertical_1j30o_gg_:after,.___SDropdownMenuList_1j30o_gg_ .___SShadowVertical_1j30o_gg_:before{width:100%;height:16px;border-radius:var(--intergalactic-control-rounded, 6px)}.___SDropdownMenuList_1j30o_gg_ .___SShadowVertical_1j30o_gg_._position_median_1j30o_gg_:before{background:var(--intergalactic-scroll-area-dropdown-menu-top,
        linear-gradient(to bottom, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowVertical_1j30o_gg_._position_median_1j30o_gg_:after{background:var(--intergalactic-scroll-area-dropdown-menu-bottom,
        linear-gradient(to top, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowVertical_1j30o_gg_._position_start_1j30o_gg_:before{background:var(--intergalactic-scroll-area-dropdown-menu-top,
        linear-gradient(to bottom, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuList_1j30o_gg_ .___SShadowVertical_1j30o_gg_._position_end_1j30o_gg_:after{background:var(--intergalactic-scroll-area-dropdown-menu-bottom,
        linear-gradient(to top, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)
      )}.___SDropdownMenuItemContainer_1j30o_gg_.__nesting-trigger_1j30o_gg_{justify-content:space-between}.___SDropdownMenuItemAddon_1j30o_gg_,.___SItemContentText_1j30o_gg_{display:inline-flex;margin-left:var(--intergalactic-spacing-1x, 4px);margin-right:var(--intergalactic-spacing-1x, 4px)}.___SDropdownMenuItemAddon_1j30o_gg_:first-child,.___SItemContentText_1j30o_gg_:first-child{margin-left:0}.___SDropdownMenuItemAddon_1j30o_gg_:last-child,.___SItemContentText_1j30o_gg_:last-child{margin-right:0}.___SDropdownMenuNesting_1j30o_gg_,.___SDropdownMenuNesting_1j30o_gg_._size_l_1j30o_gg_,.___SDropdownMenuNesting_1j30o_gg_._size_m_1j30o_gg_{padding:0}.___SDropdownMenuNesting_1j30o_gg_.__highlighted_1j30o_gg_{z-index:1;box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5)) inset}.___SDropdownNestingItem_1j30o_gg_._size_l_1j30o_gg_,.___SDropdownNestingItem_1j30o_gg_._size_m_1j30o_gg_{padding-right:0}.___SDropdownNestingItem_1j30o_gg_ .___SDropdownMenuItemContainer_1j30o_gg_{width:auto;padding-top:0;padding-bottom:0;padding-left:0;min-height:auto}.___SItemContent_1j30o_gg_:focus{outline:0}.___SItemHint_1j30o_gg_{color:var(--intergalactic-text-secondary, #6c6e79)}`,
    "1j30o_gg_"
  ), {
    __SDropdownMenuItemContainer: "___SDropdownMenuItemContainer_1j30o_gg_",
    "_nesting-trigger": "__nesting-trigger_1j30o_gg_",
    __SDropdownMenuNesting: "___SDropdownMenuNesting_1j30o_gg_",
    _size_l: "_size_l_1j30o_gg_",
    _size_m: "_size_m_1j30o_gg_",
    _highlighted: "__highlighted_1j30o_gg_",
    __SDropdownNestingItem: "___SDropdownNestingItem_1j30o_gg_",
    __SItemContent: "___SItemContent_1j30o_gg_",
    __SItemHint: "___SItemHint_1j30o_gg_",
    __SDropdownMenuList: "___SDropdownMenuList_1j30o_gg_",
    __SShadowHorizontal: "___SShadowHorizontal_1j30o_gg_",
    _position_median: "_position_median_1j30o_gg_",
    _position_start: "_position_start_1j30o_gg_",
    _position_end: "_position_end_1j30o_gg_",
    __SShadowVertical: "___SShadowVertical_1j30o_gg_",
    __SDropdownMenuItemAddon: "___SDropdownMenuItemAddon_1j30o_gg_",
    __SItemContentText: "___SItemContentText_1j30o_gg_"
  })
), U = function(_) {
  var t = _.children;
  return /* @__PURE__ */ i.createElement(de.Provider, {
    value: !0
  }, t);
}, z = /* @__PURE__ */ i.createContext({}), M = /* @__PURE__ */ function(n) {
  te(t, n);
  var _ = re(t);
  function t() {
    var a;
    Z(this, t);
    for (var r = arguments.length, o = new Array(r), e = 0; e < r; e++)
      o[e] = arguments[e];
    return a = _.call.apply(_, [this].concat(o)), C(V(a), "actionsRef", /* @__PURE__ */ i.createRef()), C(V(a), "role", "menu"), a;
  }
  return ee(t, [{
    key: "uncontrolledProps",
    value: function() {
      var r = this;
      return u(u({}, I(y(t.prototype), "uncontrolledProps", this).call(this)), {}, {
        visible: [null, function(o) {
          o === !0 && setTimeout(function() {
            var e, s, d = (e = r.menuRef.current) === null || e === void 0 ? void 0 : e.querySelectorAll('[role="menuitemcheckbox"], [role="menuitemradio"]'), l = (s = r.menuRef.current) === null || s === void 0 ? void 0 : s.querySelector('[aria-checked="true"]');
            if (l && d && r.asProps.itemsCount === void 0) {
              r.scrollToNode(l, !0);
              for (var m = 0; m < d.length; m++)
                if (d[m] === l) {
                  r.handlers.highlightedIndex(m);
                  break;
                }
            }
          }, 30);
        }]
      });
    }
  }, {
    key: "itemRef",
    value: function(r, o, e) {
      I(y(t.prototype), "itemRef", this).call(this, r, o, e), e === document.activeElement && I(y(t.prototype), "scrollToNode", this).call(this, e);
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var r = this.asProps, o = r.Children, e = r.uid, s = r.visible, d = A(o, [v.Menu.displayName]), l = d ? "igc-".concat(e, "-list") : "igc-".concat(e, "-popper");
      return u(u({}, I(y(t.prototype), "getTriggerProps", this).call(this)), {}, {
        onKeyDown: E(this.handlePreventCommonKeyDown.bind(this), this.handleOpenKeyDown.bind(this), this.handleKeyDownForMenu("trigger")),
        "aria-controls": s ? l : void 0,
        "aria-haspopup": d ? "true" : "dialog"
      });
    }
  }, {
    key: "getListProps",
    value: function() {
      return u(u({}, I(y(t.prototype), "getListProps", this).call(this)), {}, {
        onKeyDown: E(this.handlePreventCommonKeyDown.bind(this), this.handleKeyDownForMenu("list"), this.handleArrowKeyDown.bind(this))
      });
    }
  }, {
    key: "getPopperProps",
    value: function() {
      return u(u({}, I(y(t.prototype), "getPopperProps", this).call(this)), {}, {
        onKeyDown: E(this.handlePreventCommonKeyDown.bind(this), this.handlePreventPopperKeyDown.bind(this))
      });
    }
  }, {
    key: "getActionsProps",
    value: function() {
      return u(u({}, this.getListProps()), {}, {
        ref: this.actionsRef,
        onKeyDown: E(this.handlePreventTabOnActions.bind(this), this.handlePreventCommonKeyDown.bind(this), this.handleKeyDownForMenu("list"), this.handleArrowKeyDown.bind(this))
      });
    }
  }, {
    key: "getItemProps",
    value: function(r, o) {
      var e, s = this, d = this.asProps, l = d.highlightedIndex, m = d.visible, g = (e = r.index) !== null && e !== void 0 ? e : o, p = g === l, c = u(u({}, I(y(t.prototype), "getItemProps", this).call(this, r, g)), {}, {
        tabIndex: p && m ? 0 : -1,
        ref: function(w) {
          return s.itemRef(r, g, w);
        },
        actionsRef: this.actionsRef
      });
      if (r.tag === ce) {
        var f, b, S;
        c.use = (f = r.use) !== null && f !== void 0 ? f : "tertiary", c.theme = (b = r.theme) !== null && b !== void 0 ? b : "muted", c.size = (S = r.size) !== null && S !== void 0 ? S : "s";
      }
      return r.selected && (c["aria-checked"] = !0), I(y(t.prototype), "childRole", this) === "menuitemradio" && (c.onClick = function() {
        s.handlers.visible(!1);
      }), c;
    }
  }, {
    key: "handleKeyDownForMenu",
    value: function(r) {
      var o = this;
      return function(e) {
        var s, d, l = o.asProps, m = l.visible, g = l.placement, p = l.inlineActions;
        if (r === "list" && !((s = o.menuRef.current) !== null && s !== void 0 && s.contains(e.target)) && !p)
          return e.stopPropagation(), !1;
        var c = e.key === "ArrowRight" && (g == null ? void 0 : g.startsWith("right")) || e.key === "ArrowLeft" && (g == null ? void 0 : g.startsWith("left")), f = e.key === "ArrowLeft" && (g == null ? void 0 : g.startsWith("right")) || e.key === "ArrowRight" && (g == null ? void 0 : g.startsWith("left")) || e.key === "Escape", b = (d = e.target.getAttribute("role")) === null || d === void 0 ? void 0 : d.startsWith(I(y(t.prototype), "childRole", o));
        if (r === "trigger" && (!m || p) && c && b)
          return o.handlers.visible(!0), o.handlers.highlightedIndex(0), setTimeout(function() {
            var j, w = o.asProps.highlightedIndex;
            (j = o.itemRefs[w]) === null || j === void 0 || j.focus();
          }, 0), e.preventDefault(), e.stopPropagation(), !1;
        if (r === "list" && m && f && b && (!p || p && (e.key === "Escape" || o.asProps.highlightedIndex === 0))) {
          var S;
          return o.handlers.visible(!1), (S = o.triggerRef.current) === null || S === void 0 || S.focus(), e.preventDefault(), e.stopPropagation(), !1;
        }
      };
    }
  }, {
    key: "handlePreventTabOnActions",
    value: function(r) {
      if (r.key === "Tab")
        return r.stopPropagation(), r.preventDefault(), !1;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.asProps, o = this.asProps, e = o.Children, s = o.selectedIndex, d = o.interaction, l = o.timeout;
      return this.itemProps = [], /* @__PURE__ */ i.createElement(q.Provider, {
        value: s
      }, /* @__PURE__ */ i.createElement(D, h({
        timeout: l || (d === "hover" ? [0, 100] : void 0)
      }, r), /* @__PURE__ */ i.createElement(e, null)));
    }
  }]), t;
}(_e);
C(M, "displayName", "DropdownMenu");
C(M, "style", pe);
C(M, "enhance", Object.values(ae));
C(M, "defaultProps", {
  size: "m",
  defaultVisible: !1,
  defaultHighlightedIndex: 0,
  defaultSelectedIndex: 0,
  i18n: ge,
  locale: "en",
  interaction: "click",
  inlineActions: !1,
  placement: "bottom-start",
  timeout: 0
});
C(M, "nestedMenuInteraction", {
  trigger: [["onClick", "onMouseEnter"], ["onClick", "onMouseLeave"]],
  popper: [["onMouseEnter"], ["onMouseLeave"]]
});
function fe(n) {
  var _ = arguments[0], t, a = n.styles, r = n.Children, o = k;
  return t = x(a), /* @__PURE__ */ i.createElement(U, t.cn("ListBoxContextProvider", {}), /* @__PURE__ */ i.createElement(o, t.cn("SDropdownMenuList", u({}, h({
    shadow: !0
  }, _))), /* @__PURE__ */ i.createElement(k.Container, {
    tabIndex: void 0
  }, /* @__PURE__ */ i.createElement(r, t.cn("Children", {}))), /* @__PURE__ */ i.createElement(k.Bar, {
    orientation: "horizontal"
  }), /* @__PURE__ */ i.createElement(k.Bar, {
    orientation: "vertical"
  })));
}
function ve(n) {
  var _ = arguments[0], t, a = n.styles, r = N;
  return t = x(a), /* @__PURE__ */ i.createElement(r, t.cn("SDropdownMenuActions", u({}, h({}, _))));
}
function be(n) {
  var _ = arguments[0], t = n.visible, a = n.disablePortal, r = n.ignorePortalsStacking, o = n.disableEnforceFocus, e = n.interaction, s = n.autoFocus, d = n.animationsDisabled, l = {
    visible: t,
    disablePortal: a,
    ignorePortalsStacking: r,
    disableEnforceFocus: o,
    interaction: e,
    autoFocus: s,
    animationsDisabled: d
  };
  return /* @__PURE__ */ i.createElement(U, null, /* @__PURE__ */ i.createElement(v.Popper, W({}, l, {
    role: null
  }), /* @__PURE__ */ i.createElement(v.List, h({}, _))));
}
function Se(n) {
  var _ = arguments[0], t, a = n.id, r = n.styles, o = n.disabled, e = n.Children, s = n.forwardRef, d = n.role, l = n.tabIndex, m = n.actionsRef, g = n["aria-checked"], p = D.Item, c = i.useRef(), f = i.useState(!1), b = T(f, 2), S = b[0], j = b[1], w = {
    contentId: a,
    ref: G(s, c),
    role: d,
    tabIndex: l,
    ariaChecked: g
  }, H = [], L = A(e, [v.displayName], !0), K = A(e, [v.Item.Hint.displayName], !0), P = A(e, [v.Item.Content.displayName], !0) || L || K;
  if (K) {
    var F = "igc-".concat(le(), "-option-hint");
    w.hintId = F, H.push(F);
  }
  L && (w.hasSubMenu = !0), w.ariaDescribes = H, i.useEffect(function() {
    var B = function(R) {
      R.target === c.current && (j(!0), L && R.stopPropagation());
    }, $ = function(R) {
      R.target === c.current && (j(!1), m.current && (c.current.tabIndex = -1));
    };
    return document.addEventListener("focus", B, {
      capture: !0
    }), document.addEventListener("blur", $, {
      capture: !0
    }), function() {
      document.removeEventListener("focus", B, {
        capture: !0
      }), document.removeEventListener("blur", $, {
        capture: !0
      });
    };
  }, [c.current]);
  var J = ue();
  return t = x(r), /* @__PURE__ */ i.createElement(z.Provider, {
    value: w
  }, /* @__PURE__ */ i.createElement(p, t.cn("SDropdownMenuItemContainer", u({}, h({
    ref: P ? void 0 : w.ref,
    "use:highlighted": !o && S && J.current === "keyboard",
    "use:role": P ? void 0 : d,
    "use:id": P ? void 0 : a,
    "use:tabIndex": P ? void 0 : l,
    "use:aria-checked": P ? void 0 : g
  }, _))), /* @__PURE__ */ i.createElement(e, t.cn("Children", {}))));
}
function O(n) {
  var _ = se(n, n.forwardRef), t = T(_, 2), a = t[0], r = t[1], o = r.className, e = Y(r, he), s = x(n.styles);
  return /* @__PURE__ */ i.createElement(a, W({
    className: ie(s.cn("SDropdownMenuItemAddon", n).className, o) || void 0
  }, e));
}
function we() {
  var n = arguments[0];
  return /* @__PURE__ */ i.createElement(D.Trigger, h({}, n));
}
function Ie(n) {
  var _ = arguments[0], t, a = n.styles, r = N, o = i.useRef(), e = i.useContext(z), s = void 0;
  e.hasSubMenu && (s = "true");
  var d = i.useState(new Set(e.ariaDescribes)), l = T(d, 2), m = l[0], g = l[1];
  return i.useEffect(function() {
    var p = o.current, c = p == null ? void 0 : p.parentElement;
    c.getAttribute("aria-haspopup") === "true" && c.getAttribute("aria-describedby") && g(function(f) {
      return f.add(c.getAttribute("aria-describedby")), new Set(f);
    });
  }, [e.ariaDescribes]), t = x(a), /* @__PURE__ */ i.createElement(r, t.cn("SItemContent", u({}, h({
    role: e.role,
    id: e.contentId,
    tabIndex: e.tabIndex,
    ref: G(e.ref, o),
    "use:aria-describedby": X(m).join(" "),
    "aria-haspopup": e.hasSubMenu ? "true" : void 0,
    "aria-expanded": s,
    "aria-checked": e.ariaChecked,
    alignItems: "center",
    justifyContent: e.hasSubMenu ? "space-between" : void 0
  }, _))));
}
function ye(n) {
  var _ = arguments[0], t, a = n.styles, r = me;
  return t = x(a), /* @__PURE__ */ i.createElement(r, t.cn("SItemContentText", u({}, h({}, _))));
}
function xe(n) {
  var _ = arguments[0], t, a = n.styles, r = N, o = i.useContext(z), e = o.hintId;
  return t = x(a), /* @__PURE__ */ i.createElement(r, t.cn("SItemHint", u({}, h({
    id: e,
    "aria-hidden": "true"
  }, _))));
}
function De(n) {
  var _ = arguments[0], t, a = D.Item;
  return t = x(n.styles), /* @__PURE__ */ i.createElement(a, t.cn("SDropdownMenuItemContainer", u({}, h({
    variant: "hint"
  }, _))));
}
function je(n) {
  var _ = arguments[0], t, a = D.Item;
  return t = x(n.styles), /* @__PURE__ */ i.createElement(a, t.cn("SDropdownMenuItemContainer", u({}, h({
    variant: "title"
  }, _))));
}
function Ce(n) {
  var _ = arguments[0], t = n.forwardRef;
  return /* @__PURE__ */ i.createElement(v.Item, h({
    ref: t
  }, _));
}
function Me(n) {
  var _ = arguments[0], t = n.forwardRef;
  return /* @__PURE__ */ i.createElement(v.Item.Content, h({
    tag: v.Trigger,
    ref: t,
    "use:role": "menuitem"
  }, _));
}
var v = oe(M, {
  Trigger: we,
  Popper: D.Popper,
  List: fe,
  Actions: ve,
  Menu: be,
  Item: [Se, {
    Addon: O,
    Content: Ie,
    Text: ye,
    Hint: xe
  }],
  /**
   * @deprecated. Use just Item. See examples on
   */
  Nesting: [Ce, {
    Trigger: Me,
    Addon: O
  }],
  ItemTitle: je,
  ItemHint: De,
  Group: D.Group
}, {
  parent: [D]
});
v.selectedIndexContext = q;
export {
  v as default
};
